<script setup lang="ts">
import { X } from "lucide-vue-next";
import {
  ToastClose as ToastCloseComponent,
  type ToastCloseProps,
} from "reka-ui";
import { type HTMLAttributes, computed } from "vue";
import { cn } from "@/lib/utils";

interface Props extends ToastCloseProps {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();

const delegatedProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});
</script>

<template>
  <ToastCloseComponent
    v-bind="delegatedProps"
    :class="
      cn(
        'absolute right-1 top-1 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100 group-[.destructive]:text-pando-delayed group-[.destructive]:hover:text-white group-[.destructive]:focus:ring-error group-[.destructive]:focus:ring-offset-error',
        props.class,
      )
    "
  >
    <X class="h-4 w-4" />
  </ToastCloseComponent>
</template>
